<template lang="pug">
//- 有订单未支付弹窗
.nopay-container(v-if="show", @touchmove.prevent)
  .nopay-block
    .first-block
      img(src="https://m.hellobike.com/resource/helloyun/08345/PAlxmkps4x.png" @click="close")
    .nopay-title
      span 待支付订单
    .nopay-time
      div(v-if="timeout>0")
        span 支付倒计时：
        span.redtime {{h}}:{{m}}:{{s}}
    .middle-block
      .middle-propVersion(v-if="noPayData.propVersion==='ride'") · 随心骑版
      .middle-propVersion(v-if="noPayData.propVersion==='ladder'") · 畅享出行版
      .middle-font
        .middle-small(v-if="noPayData.orderOptType===30") 连续包月
        .middle-small(v-else) 开通一个月
        .middle-big
          .money {{noPayData.price}}
          .yuan 元
        .middle-word 日常价{{noPayData.markedPrice}}元
    .btn-block
      .close-btn(@click="closeModal") 取消订单
      .pay-btn(@click="toPay") 支付并开通
  .shadow
</template>
<script>
import Lottie from '@/components/lottie';
import { UBTUtils } from '../../../../utils/ubt';

export default {
  components: {
    Lottie,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    noPayData: {
      type: Object,
      required: true,
    },
    transType: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      h: '',
      m: '',
      s: '',
      timer: null,
      timeout: 0,
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.timeout = this.noPayData.expiredTimeMillis;
        this.open();
      }
    },
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    closeModal() {
      this.$emit('cancelOrder');
      this.$emit('close');
    },
    close() {
      this.$emit('close');
    },
    toPay() {
      UBTUtils.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_pay_Popup',
        categoryId: 'platform',
        businessInfo: {},
      });
      // 续费页面需要goodsGuid
      this.$emit('open', true, this.noPayData.orderOptType, this.noPayData.price, this.noPayData.goodsGuid);
      this.$emit('close');
    },
    open() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.timeout <= 0) {
            this.$emit('refresh');
            this.timer = null;
            clearInterval(this.timer);
            return;
          }
          this.showTime(this.timeout);
          this.timeout -= 1000;
        }, 1000);
      }
    },
    showTime(timeout) {
      // 后台给我的是10位 精确到秒的  所有下面我就除以了1000，不要小数点后面的
      // eslint-disable-next-line no-console
      if (timeout) {
        const t = timeout;
        // eslint-disable-next-line no-console
        // 如果后台给的是毫秒 上面不用除以1000  下面的计算时间也都要除以1000 这里我去掉1000了
        let d = Math.floor(t / 60 / 60 / 24); // 天 var d=Math.floor(t/1000/60/60/24)
        // eslint-disable-next-line no-mixed-operators
        const h = Math.floor((t / 1000 / 60 / 60) % 24);
        // 时 var h=Math.floor(t/1000/60/60%24)
        // eslint-disable-next-line no-mixed-operators
        const m = Math.floor((t / 1000 / 60) % 60); // 分 var m=Math.floor(t/1000/60%60)
        // eslint-disable-next-line no-mixed-operators
        const s = Math.floor((t / 1000) % 60); // 秒 var s=Math.floor(t/1000%60)
        if (parseInt(d, 10) < 10) {
          d = `0${d}`;
        }
        if (parseInt(h, 10) < 10) {
          this.h = `0${h}`;
        } else {
          this.h = `${h}`;
        }
        if (parseInt(m, 10) < 10) {
          this.m = `0${m}`;
        } else {
          this.m = `${m}`;
        }
        if (parseInt(s, 10) < 10) {
          this.s = `0${s}`;
        } else {
          this.s = `${s}`;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.nopay-container {
  .nopay-block {
    width: 3.2rem;
    height: 2.66rem;
    background-image: url(https://m.hellobike.com/resource/helloyun/08345/bt0QnWqVbI.png?x-oss-process=image/quality,q_80);
    background-size: 100% 100%;
    border-radius: 0.12rem;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 330;
    padding: 0.12rem 0.12rem 0.2rem 0.12rem;

    .first-block {
      display: flex;
      justify-content: flex-end;

      img {
        width: 0.16rem;
        height: 0.16rem;
      }
    }

    .nopay-title {
      display: flex;
      justify-content: center;
      font-size: 0.18rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 650;
      color: #242729;
    }

    .nopay-time {
      margin-top: 0.04rem;
      margin-bottom: 0.06rem;
      display: flex;
      justify-content: center;
      font-size: 0.12rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;

      .redtime {
        color: #f72626;
      }
    }

    .middle-block {
      margin: 0 auto;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/ncGNI_9Rz6.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      width: 100%;
      padding: 0 0.14rem;
      height: 1.05rem;
      position: relative;

      .middle-propVersion {
        position: absolute;
        top: 0.175rem;
        left: 1.34rem;
        color: #75431e;
        font-size: 0.15rem;
      }

      .middle-font {
        display: flex;
        padding-top: 0.42rem;

        .middle-big {
          margin: 0.01rem 0.01rem 0 0.01rem;
          font-size: 0.24rem;
          font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
          font-weight: 600;
          color: #f24000;
          display: flex;

          .money {
            display: inline-block;
            margin: 0.01rem 0.01rem 0 0.01rem;
          }

          .yuan {
            line-height: 0.42rem;
            font-size: 0.12rem;
          }
        }

        .middle-small {
          margin-top: 0.13rem;
          margin-left: 0.05rem;
          font-size: 0.12rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #fa2a00;
          line-height: 0.17rem;
        }

        .middle-word {
          margin-top: 0.14rem;
          margin-left: 0.05rem;
          font-size: 0.12rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: rgba(111, 57, 0, 0.6);
          line-height: 0.17rem;
        }
      }
    }

    .btn-block {
      display: flex;
      justify-content: space-between;
      padding: 0 0.04rem;
      margin-top: 0.11rem;

      .close-btn {
        width: 1.4rem;
        height: 0.4rem;
        background: #f0f3f5;
        border-radius: 0.08rem;
        font-size: 0.16rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #5a6066;
        line-height: 0.4rem;
        text-align: center;
      }

      .pay-btn {
        width: 1.4rem;
        height: 0.4rem;
        background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
        border-radius: 0.08rem;
        font-size: 0.16rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #fff;
        line-height: 0.4rem;
        text-align: center;
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 300;
  }
}
</style>
